
import { FETCH_C_TERMS, CREATE_C_TERM, UPDATE_C_TERM, DELETE_C_TERM} from '../actions';
const initialState = {
  selectedToDelete: null,
  newCTerm: null,
  updatedCTerm: null,
  cTerms: [],
  loading: false,
  error:null,
  selectedToDeleteError:null,
  newCTermError:null,
  updatedCTermError:null,
  cTermsError:null
};

function contractTermsReducer(state = initialState, action) {
  let selectedToDelete,
    newCTerm,
    updatedCTerm,
    cTerms;

  switch (action.type) {
    case `${UPDATE_C_TERM}_PENDING`:
    case `${CREATE_C_TERM}_PENDING`:
    case `${FETCH_C_TERMS}_PENDING`:
    case `${DELETE_C_TERM}_PENDING`:
      return { ...state, loading: true };

    case `${UPDATE_C_TERM}_FULFILLED`:
      updatedCTerm = action.payload.data;
      return { ...state, loading: false, updatedCTerm };

    case `${CREATE_C_TERM}_FULFILLED`:
      newCTerm = action.payload.data;
      return { ...state, loading: false, newCTerm };

    case `${FETCH_C_TERMS}_FULFILLED`:
      cTerms = action.payload.data;
      return { ...state, loading: false, cTerms };

    case `${DELETE_C_TERM}_FULFILLED`:
      selectedToDelete = action.payload.data;
      return { ...state, loading: false, selectedToDelete };

    case `${UPDATE_C_TERM}_REJECTED`:
      return {...state, loading: false, updatedCTermError: `${action.payload.message}`, state: initialState };

    case `${CREATE_C_TERM}_REJECTED`:
      return {...state, loading: false, newCTermError: `${action.payload.message}`, state: initialState };

    case `${FETCH_C_TERMS}_REJECTED`:
      return {...state, loading: false, cTermsError: `${action.payload.message}`, state: initialState };

    case `${DELETE_C_TERM}_REJECTED`:
      return {...state, loading: false, selectedToDeleteError: `${action.payload.message}`, state: initialState };

    default:
      return state;
  }
}

export default contractTermsReducer;
